/* @ts-self-types="./payments_wasm.d.ts" */
import * as wasm from "./payments_wasm_bg.wasm";
import { __wbg_set_wasm } from "./payments_wasm_bg.js";

__wbg_set_wasm(wasm);
wasm.__wbindgen_start();
export {
    AllocationResult, allocateExpensesFirst, allocateExpensesFirstInFirstOut, allocateFirstInFirstOut, allocateProportional, feeBasisPoints, moneyCheckedAdd, moneyCheckedMultiplyByScalar, moneyCheckedNegate, moneyCheckedSubtract, moneyCheckedSum, moneyRoundToCents
} from "./payments_wasm_bg.js";
